export default __webpack_public_path__ + "static/media/fourthBg.cee85f75.png";